<script src="../thesaurus-concept-dialog/thesaurus-concept-dialog.component.ts"></script>
<section class="sh-dialog__content">
    @if (errorKey) {
        <sh-notification [message]="errorKey | translate" [type]="NotificationType.Error" [icon]="'delete'"></sh-notification>
    }

    <sh-form-select
        [options]="rightsOptions$ | async"
        [control]="rightsControl"
        [label]="'sharing.dialog.controls.rights' | translate"
        [id]="'sharing.dialog.controls.rights'"
        [showEmptyOption]="false"
    ></sh-form-select>

    <div class="sh-form-group">
        <sh-form-checkbox-base
            [formControl]="loginRequiredControl"
            [label]="'sharing.dialog.controls.login-required' | translate"
            [id]="'sharing.dialog.controls.login-required'"
        >
        </sh-form-checkbox-base>
    </div>

    <sh-form-date
        [control]="expirationControl"
        [label]="'sharing.dialog.controls.expiration' | translate"
        [id]="'sharing.dialog.controls.expiration'"
        [min]="minDate.toString()"
        [errorMsg]="'sharing.dialog.errors.future-date' | translate"
    ></sh-form-date>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <sh-copy-button
            [data]="(this.share$ | async)?.ShareLink"
            [label]="mainButtonKey | translate"
            [disabled]="!expirationControl.valid || inProgress"
            (copySuccess)="copySuccess()"
        >
        </sh-copy-button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ data.cancel }}</button>
    </div>
</footer>
